import { FormControl } from '@angular/forms';

import { CustomFieldConditionEnum } from 'src/ajs-app/components/parameters/quick-replies/joint-diagram/conditions-on-custom-fields/custom-field-condition.enum';
import { MessageCondition } from '../shared/message-condition/message-condition.model';
import { TriageAction } from './triage-action';
import { TriggerEventType } from './trigger-event';

TriageRuleEditionController.$inject = ['$scope', '$mdDialog', 'rule', 'TriageFactory', 'SiteFilterHelperFactory'];
export function TriageRuleEditionController($scope, $mdDialog, rule, TriageFactory, SiteFilterHelperFactory) {

  $scope.ok = ok;
  $scope.cancel = cancel;
  $scope.addCondition = addCondition;
  $scope.removeCondition = removeCondition;
  $scope.addAction = addAction;
  $scope.removeAction = removeAction;
  $scope.dropdownItems = TriageFactory.dropdownItems;
  $scope.sitesCtrl;
  $scope.isAllActionFormsValid = isAllActionFormsValid;
  $scope.checkConditionsValidity = checkConditionsValidity;

  $scope.isAllActionFormsValidBoolean = true;
  $scope.hasAtLeastOneConditionInvalid = false;

  init();

  function ok() {
    $mdDialog.hide($scope.rule);
  }

  function cancel() {
    $mdDialog.cancel();
  }

  function addCondition() {
    $scope.rule.conditions.push(new MessageCondition());
    checkConditionsValidity();
  }

  function removeCondition(index) {
    $scope.rule.conditions.splice(index, 1);
    checkConditionsValidity();
  }

  function addAction() {
    $scope.rule.actions.push(new TriageAction());
  }

  function removeAction(index) {
    $scope.rule.actions.splice(index, 1);
  }


  function updateConditionsAndActionsOnTriggerTypeChange(newTriggerType) {
    const excludedConditionCodes = newTriggerType === 'received'
      ? ['help-request-answered', 'older-than', 'younger-than', 'auto-assigned']
      : [];
    excludedConditionCodes.push('site'); // there is a special column to filter by
    $scope.excludedConditionCodes = excludedConditionCodes;
    $scope.rule.conditions.forEach((condition, index) => {
      if (excludedConditionCodes.includes(condition.typeCode)) {
        $scope.rule.conditions[index] = new MessageCondition(); // reset any previous conditions whose type is now not allowed
      }
    });
    checkConditionsValidity();
  }

  function isAllActionFormsValid() {
    $scope.isAllActionFormsValidBoolean = $scope.rule.actions.every(action => {
      // undefined is not invalid (if any other action in addition to random dispatch action)
      return action.isFormValid !== false;
    });
  }

  function checkConditionsValidity() {
    const hasAtLeastOneConditionInvalid = $scope.rule.conditions.some((condition) => {
      if (condition.typeCode === 'custom-field') {
        const { selectedCustomField, selectedCondition, comparedValue } = condition.parameters;
        const invalidComparedValue = selectedCondition !== CustomFieldConditionEnum.IS_NOT_NULL && selectedCondition !== CustomFieldConditionEnum.IS_NULL && comparedValue === null;
        return !selectedCustomField || !selectedCondition || invalidComparedValue;
      }
    });
    $scope.hasAtLeastOneConditionInvalid = hasAtLeastOneConditionInvalid;
  }

  function init() {
    $scope.rule = rule;
    // Mechanism to force a distinction by key between sites and site groups.
    $scope.sitesCtrl = new FormControl(SiteFilterHelperFactory.convertSiteAndSiteGroupsToKey(rule.siteIds, rule.siteGroupIds))
    rule.initIsAllSites();
    $scope.triggerTypeCodes = TriggerEventType.codes();
    $scope.triggerEventType = rule.triggerEvent.typeCode;
    $scope.$watch('triggerEventType', updateConditionsAndActionsOnTriggerTypeChange);

    $scope.sitesCtrl.valueChanges.subscribe(keys => {
      if (keys) {
        $scope.rule.sites = keys
      }
    })
  }

}
